module.exports = __webpack_public_path__ + "static/GorditaBlack-b608f6bc4e690f7f1378a5df05dd0e12.woff2";